// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YPtsgaEOeBFV2L {
  display: flex;
  position: fixed;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  overflow: auto;
  background: rgba(0, 0, 0, 0.75);
  scrollbar-gutter: stable both-edges;
}
@supports (height: 100dvh) {
  .YPtsgaEOeBFV2L {
    width: 100dvw;
    height: 100dvh;
  }
}
@media print {
  .YPtsgaEOeBFV2L {
    /* stylelint-disable-next-line declaration-no-important */
    display: block !important;
    /* stylelint-disable-next-line declaration-no-important */
    position: relative !important;
    /* stylelint-disable-next-line declaration-no-important */
    width: auto !important;
    /* stylelint-disable-next-line declaration-no-important */
    height: auto !important;
    /* stylelint-disable-next-line declaration-no-important */
    max-height: 100% !important;
    /* stylelint-disable-next-line declaration-no-important */
    overflow: scroll !important;
  }
}
.uIImyziS34erOZ {
  position: relative;
  width: auto;
  margin: var(--ds-space-600, 48px) var(--ds-space-0, 0);
  background: transparent;
}
.uIImyziS34erOZ:focus {
  outline: none;
}
@media print {
  .uIImyziS34erOZ {
    width: 100%;
    margin: var(--ds-space-0, 0);
  }
}
.NU3Yu9KTws207g {
  align-items: flex-start;
}
.s_AQXRHWnhI4mi {
  align-items: center;
}
.ZZivW1yefejNMR {
  align-items: flex-end;
}
.uvwWACMMVfl6tO {
  background: var(--ds-blanket, #091e427d);
  -webkit-backdrop-filter: blur(2px);
          backdrop-filter: blur(2px);
}
@media only screen and (max-width: 750px) {
  .uIImyziS34erOZ {
    width: 100%;
  }
}
@media only screen and (max-width: 600px), only screen and (max-width: 450px) {
  .uIImyziS34erOZ {
    width: 100%;
    margin: var(--ds-space-0, 0);
  }
}
`, ""]);
// Exports
export var overlay = `YPtsgaEOeBFV2L`;
export var contents = `uIImyziS34erOZ`;
export var alignTop = `NU3Yu9KTws207g`;
export var alignCenter = `s_AQXRHWnhI4mi`;
export var alignBottom = `ZZivW1yefejNMR`;
export var effectBlur = `uvwWACMMVfl6tO`;
export default ___CSS_LOADER_EXPORT___;
